const pageStyles = {
  page: {
    mt: 10,
    px: 2,
    pb: 2
  },
  tableContainer: {
    mt: 3,
    height: '75vh'
  }
};

export default pageStyles;
